<div class="container-oferta-facultad">
    <div class=" title-card " [style.background-color]="info?.venue?.color">
        <h3 class="quicksand-bold">OFERTA ACADÉMICA</h3>
    </div>
    <div class="width-paginate container-carreras-grado">
        <div class="header-carreras-grado">
            <h3 class="subtitle-oferta quicksand-bold">Carreras de grado</h3>
            <p class="nunito-medium">
                               {{ info?.academicOffer?.gradoTexto}}
            </p>
        </div>
    </div>
    <div class="width-paginate carreras-corrousel-container">
        <app-carrousel-facultades  [data]="info"  [cards]="info?.gradoCareers"></app-carrousel-facultades>
    </div >

        <div *ngIf="info?.academicOffer?.posgradoVistaDestacada" class="width-paginate container-carreras-grado">
        <div class="header-carreras-grado">
            <h3 class="subtitle-oferta quicksand-bold">Carreras de posgrado</h3>
            <p class="nunito-medium">
                {{ info?.academicOffer?.posgradoTexto}}
            </p>
        </div>
    </div>
    <div *ngIf="info?.academicOffer?.posgradoVistaDestacada" class="width-paginate carreras-corrousel-container">
        <app-carrousel-facultades  [data]="info" [linkCarrers]="info?.posgradoAreas?.[0] ? info.posgradoAreas[0] + '?facultad=' + info?.venue?.id : '#'" [cards]="info?.posgradoCareers" [posgrado]="true"></app-carrousel-facultades>
    </div>
    <div class="width-paginate container-carreras-grado">

        <section class="seccion-posgrados">
            <div class="bloque-posgrado" *ngIf="!info?.academicOffer?.posgradoVistaDestacada">
                <h2 #blockTitle class="subtitle-oferta  quicksand-bold">Carreras de Posgrado</h2>

                <div class="contenido-bloque">
                    <div class="contenedor-imagen imagen-carreras">
                        <img class="desk" onerror="this.src='./assets/facultades/ucaPosgrados.jpg'" [src]="info?.academicOffer?.posgradoImagen"  alt="UCA Posgrados">
                        <img class="mob" onerror="this.src='./assets/facultades/ucaPosgrados.jpg'" [src]="info?.academicOffer?.posgradoImagenMobile"  alt="UCA Posgrados">
                    </div>

                    <div class="info-bloque">
                        <p #description class="texto-descripcion nunito-medium">
                                            {{ info?.academicOffer?.posgradoTexto}}

                        </p>
                       <a [href]="info?.posgradoAreas?.[0] ? info.posgradoAreas[0] + '?facultad=' + info?.venue?.id : '#'"
                               target="_blank" 
                                    rel="noopener noreferrer">
                                 <button class="btn-posgrado nunito-medium zoomIn">VER CARRERAS</button>
                         </a>
                    </div>
                </div>
            </div>
            <div class="bloque-posgrado ">
                <h2 #blockTitle class="subtitle-oferta  quicksand-bold">Cursos de Posgrado - Educación continua</h2>
                <div class="contenido-bloque">
                    <div class="contenedor-imagen">
                     <img class="desk"  onerror="this.src='./assets/facultades/educacion-continua.jpg'"  [src]="info?.academicOffer?.continuaImagen" alt="UCA Educación Continua">
                     <img class="mob"  onerror="this.src='./assets/facultades/educacion-continua.jpg'"  [src]="info?.academicOffer?.continuaImagenMobile" alt="UCA Educación Continua">
                    </div>

                    <div class="info-bloque">
                        <p #description class="texto-descripcion  nunito-medium">
                                           {{ info?.academicOffer?.continuaTexto}}

                        </p>
                <div class="contenedor-botones-iconos">
                    <a *ngFor="let btn of info?.educacionContinuaAreas" 
                       [href]="'/es/' + btn.url" 
                       target="_blank" 
                       rel="noopener noreferrer"
                       class="btn-icono-posgrado-link">
                        <button [style.border-color]="info?.venue?.color" class="btn-icono-posgrado zoomIn">
                            <!-- Recuerda usar [src]="btn.file" con corchetes para que evalúe la variable -->
                            <img [src]="btn.file" [alt]="btn.name" class="icono-btn-img">
                            <span class="nunito-bold">{{btn.name}}</span>
                        </button> 
                    </a>
                </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<hr class="divider desk" [style.background-color]="info?.venue?.color" style="height: 20px;margin:0px 0px 20px 0px;">
<hr class="divider mob" [style.background-color]="info?.venue?.color" style="height: 12px; margin:0px 0px 25px 0px!important;">
